module.exports = __webpack_public_path__ + "img/img_sub_prod_jbotportal.9977235e.svg";